export const FETCH_CATALOG = 'commons/FETCH_CATALOG';
export const FETCH_CATALOG_SUCCEEDED = 'commons/FETCH_CATALOG_SUCCEEDED';
export const FETCH_CATALOG_FAILED = 'commons/FETCH_CATALOG_FAILED';
